import React, { useState, useCallback } from 'react'
import { Modal, Button, Typography } from 'antd'
import * as Icons from '@ant-design/icons'
import _ from 'lodash'

import {
  useRegisteredShortcuts,
  useGlobalShortcut,
  getMatcher
} from './shortcuts'

export function ShortcutsModalButton() {
  const [open, setOpen] = useState(false)
  const getRegisteredShortcuts = useRegisteredShortcuts()

  const handleToggle = useCallback(function () {
    setOpen(value => !value)
  }, [])
  const handleClose = useCallback(function () {
    setOpen(false)
  }, [])

  useGlobalShortcut(
    getMatcher({ name: 'Help', group: 'Help' }, ['?', '/'], {
      ctrlOrCommand: true
    }),
    handleToggle
  )

  return (
    <>
      <Button
        onClick={handleToggle}
        type="text"
        icon={<Icons.QuestionCircleFilled />}
      />

      <Modal
        title="Keyboard Shortcuts"
        icon={<Icons.QuestionCircleFilled />}
        open={open}
        afterClose={handleClose}
        onCancel={handleClose}
        footer={null}
        keyboard
        maskClosable
        closable
        width={'65rem'}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: '1rem',
            maxHeight: 'calc(100vh - 200px)',
            overflowY: 'auto'
          }}
        >
          {_(getRegisteredShortcuts())
            .values()
            .groupBy(shortcut => shortcut.group)
            .map(actionGroup => {
              const groupName = actionGroup[0].group ?? 'Other'

              return (
                <div key={groupName} style={{ marginBottom: '1rem' }}>
                  <Typography.Title level={5}>{groupName}</Typography.Title>

                  <table
                    style={{
                      marginLeft: '4px'
                    }}
                  >
                    <tbody>
                      {_(actionGroup)
                        .uniqBy(action => action.name)
                        .map(action => {
                          const { combination, name } = action

                          return (
                            <tr key={name || combination}>
                              <td style={{ minWidth: '12rem' }}>
                                <Typography.Text>{name}</Typography.Text>
                              </td>
                              <td>
                                <Typography.Text mark>
                                  {combination}
                                </Typography.Text>
                              </td>
                            </tr>
                          )
                        })
                        .value()}
                    </tbody>
                  </table>
                </div>
              )
            })
            .value()}
        </div>
      </Modal>
    </>
  )
}
